import React from 'react';
import { Helmet } from 'react-helmet';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import MedicalFormArea from './MedicalFormArea/MedicalFormArea';
import { getFAQSchema } from './MedicalFormArea/faqData';

const MedicalFormLanding = () => {
  // Get the FAQ schema from the shared data source
  const faqSchema = getFAQSchema();

  return (
    <>
      <Helmet>
        <title>South Vancouver Medical Clinic | Form Completion Service</title>
        <link rel="canonical" href="https://southvanmed.com/medicalform" />
        <meta name="description" content="Complete your medical forms starting at $250. We provide quick processing for disability, insurance, and return-to-work forms within 1-2 business days." />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <CommonPageHeader 
        title="Need a Form Filled Out? We Can Help." 
        subtitle="Medical Form Service" 
        pageDescription="At the South Van Medical Clinic, we offer a convenient service to help with your paperwork needs. No appointment necessary."
      />

      <MedicalFormArea />
    </>
  );
};

export default MedicalFormLanding;